import React, { useEffect, useState } from "react";
import {  Box, IconButton,MenuItem,TextField, Tooltip,} from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import ExcelIcon from "@mui/icons-material/CloudDownload";
import SearchIcon from "@mui/icons-material/Search";
import AttachFileIcon from "@mui/icons-material/AttachFile";  
import { getLocation } from "redux/actions/Master";
import LocationTable from "./LocationTable";
import { useDispatch, useSelector } from "react-redux";
import AppInfoView from "@crema/core/AppInfoView";
import AppsContainer from "@crema/core/AppsContainer";
import AppsPagination from "@crema/core/AppsPagination";
import AppsContent from "@crema/core/AppsContainer/AppsContent";
import AppsHeader from "@crema/core/AppsContainer/AppsHeader";
import AppSearchBar from "@crema/core/AppSearchBar";
import { AppState } from "redux/store";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";

const Location: React.FC = () => {
  const dispatch = useDispatch();
  const { location, locationCount } = useSelector<AppState, AppState["master"]>(state => state.master);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [search, setSearchQuery] = useState<string>(""); 
  const [records, setRecords] = useState<string>("20");
  const [selectFilter, setSelectFilter] = useState<string>("");
  const [fromDate, setFromDate] = useState<string>("");
  const [toDate, setToDate] = useState<string>("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  useEffect(() => {
    dispatch(getLocation(search, page));
  }, [dispatch, search, page]);

  const handlePageChange = (_: React.ChangeEvent<unknown> | null, value: number) => {
    setPage(value);
  };

  const onSearchLocation = (value: string) => {
    setSearchQuery(value);
    setPage(0);
  };

  const handleAddLocationClick = () => {
    navigate("/master/manageDeviceLocation/LocationCreate");
  };

  const handleDownloadSample = () => {
    const sampleData = location.map((loc) => ({
      sNo: loc.sNo,
      deviceIp: loc.deviceIp,
      npName: loc.npName,
      pinCode: loc.pinCode,
      latitude: loc.latitude,
      longitude: loc.longitude,
      hostName: loc.hostName,
      serviceVlanid: loc.serviceVlanid,
      nasPortId: loc.nasPortId,
      voltage: loc.voltage,
      switchConnectivity: loc.switchConnectivity,
      switchPortNo: loc.switchPortNo,
      switchPortConnectivity: loc.switchPortConnectivity,
      mediaConverter: loc.mediaConverter,
      location: loc.location,
      distanceFromCo: loc.distanceFromCo,
      powerBackup: loc.powerBackup,
      backupOwnership: loc.backupOwnership,
      distanceFromLink: loc.distanceFromLink,
      status: loc.status,
    }));

    const ws = XLSX.utils.json_to_sheet(sampleData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Locations");
    XLSX.writeFile(wb, "DeviceLocation-Sample.xlsx");
  };

  const handleExportToExcel = () => {
    const exportData = location.map((loc) => ({
      sNo: loc.sNo,
      deviceIp: loc.deviceIp,
      npName: loc.npName,
      pinCode: loc.pinCode,
      latitude: loc.latitude,
      longitude: loc.longitude,
      hostName: loc.hostName,
      serviceVlanid: loc.serviceVlanid,
      nasPortId: loc.nasPortId,
      voltage: loc.voltage,
      switchConnectivity: loc.switchConnectivity,
      switchPortNo: loc.switchPortNo,
      switchPortConnectivity: loc.switchPortConnectivity,
      mediaConverter: loc.mediaConverter,
      location: loc.location,
      distanceFromCo: loc.distanceFromCo,
      powerBackup: loc.powerBackup,
      backupOwnership: loc.backupOwnership,
      distanceFromLink: loc.distanceFromLink,
      status: loc.status,
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Locations");

    XLSX.writeFile(wb, "DeviceLocation-Export.xlsx");
  };

  const handleSearch = () => {
    setSearchQuery(search);
  };

  const uploadFile = async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await fetch("", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("File upload failed");
      }

      alert("File uploaded successfully!");
    } catch (error) {
      console.error(error);
      alert("Failed to upload the file.");
    }
  };

  const handleUploadClick = () => {
    if (selectedFile) {
      uploadFile(selectedFile);
    } else {
      alert("Please select a file first.");
    }
  };



  return (
    <>
      <AppsContainer
        title={
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
            <Box component="span" sx={{ fontSize: 16, fontWeight: "bold", color: "text.primary", flex: 1 }}>
              Device Location
            </Box>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Tooltip title="Upload File">
                <Box
                  sx={{
                    padding: "10px",
                    border: "1px dashed #ccc",
                    borderRadius: "4px",
                    minWidth: "20px",
                    textAlign: "center",
                    display: "inline-block",
                    cursor: "pointer",
                    backgroundColor: "#f5f5f5",
                    color: "#757575",
                  }}
                  onClick={() => document.getElementById("fileInput")?.click()}
                >
                  <AttachFileIcon />
                  <input
                    id="fileInput"
                    hidden
                    type="file"
                  />
                </Box>
              </Tooltip>

              <Tooltip title="Upload">
                <IconButton color="primary" onClick={handleUploadClick}>
                  <UploadIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Download Sample">
                <IconButton color="primary" onClick={handleDownloadSample}>
                  <DownloadIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Export to Excel">
                <IconButton color="primary" onClick={handleExportToExcel}>
                  <ExcelIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Add Location">
                <IconButton color="primary" onClick={handleAddLocationClick}>
                  <AddIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        }
        fullView
      >
         <AppsHeader>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
            <TextField
              select
              label="Records"
              variant="outlined"
              size="small"
              value={records}
              onChange={(e) => setRecords(e.target.value)}
              sx={{ width: 120 }}
            >
              <MenuItem value="20">20</MenuItem>
              <MenuItem value="50">50</MenuItem>
              <MenuItem value="100">100</MenuItem>
            </TextField>
            <TextField
              select
              label="Select Filter"
              variant="outlined"
              size="small"
              value={selectFilter}
              onChange={(e) => setSelectFilter(e.target.value)}
              sx={{ width: 160 }}
            >
              <MenuItem value="Filter 1">Select Filter</MenuItem>
              <MenuItem value="Filter 2">DeviceID</MenuItem>
              <MenuItem value="Filter 3">Network Partner</MenuItem>
            </TextField>
            <AppSearchBar
              iconPosition="right"
              overlap={false}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                onSearchLocation(event.target.value)
              }
              placeholder="Search here"
              sx={{ flex: 1, marginRight: 2 }}
            />
            <TextField
              size="small"
              type="date"
              label="From Date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              size="small"
              type="date"
              label="To Date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
            <IconButton color="primary" onClick={handleSearch}>
              <SearchIcon />
            </IconButton>
          </Box>
        </AppsHeader>

        <AppsContent sx={{ paddingTop: 2.5, paddingBottom: 2.5 }}>
          <LocationTable location={location} />
          <AppsPagination
            rowsPerPage={parseInt(records)}
            count={locationCount}
            page={page}
            onPageChange={handlePageChange}
          />
        </AppsContent>
      </AppsContainer>

      <AppInfoView />
    </>
  );
};

export default Location;